import React from 'react';
import { message, Tabs } from 'antd';
import ItemsWiki from '../../agnoia/item/wiki/ItemsWiki';
import { useState } from 'react';
import { useEffect } from 'react';
import {useFetch} from '@utils'
import { useContext } from 'react';
import { appContext } from '../../../AppContext';
import ItemRecepiesWiki from '../../agnoia/item/wiki/ItemRecepiesWiki';

const { TabPane } = Tabs;

export default function AgnoiaItemWiki() {

    const [doFetch] = useFetch();
    const [tools, setTools] = useState([])
    const [appState] = useContext(appContext);

    useEffect(() => {
      refreshTools();
    }, // eslint-disable-next-line
    [])
  
    function refreshTools()
    {
        const url = `/api/item/${appState.storyId}/GetAllTools`
        doFetch(url)
        .then((response) => onInventoryLoaded(response.isSuccess, response.result))
  
        function onInventoryLoaded(isSuccess, result) { 
          if(isSuccess) {
            setTools(result);
            return;
          }
          setTools([])
          message.error('Could not get Tools');
        }
    }
      
    
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Item list" key="1">
                <ItemsWiki tools={tools}/>
            </TabPane>
            <TabPane tab="Recipes" key="2">
                <ItemRecepiesWiki tools={tools}/>
            </TabPane>
        </Tabs>
    )
}